// Ô "Tìm menu" trên thanh bên (yêu cầu 28/10/2026): Tổng Giám đốc và Giám đốc
// thấy gần như cả menu, dò bằng mắt rất lâu. Chỉ hai vai đó có ô; vai khác
// menu ngắn nên vẽ y như cũ.
import { ROLE } from "@/lib/auth/roles";
import { removeAccents } from "@/lib/orderUtils";
import type { NavGroup, NavItem } from "./nav-items";

const SEARCH_ROLES: readonly string[] = [ROLE.Admin, ROLE.Director];

export function canSearchNav(role: string | undefined): boolean {
  return !!role && SEARCH_ROLES.includes(role);
}

/** Bỏ dấu + chữ thường để "luong" khớp "Lương", "dat lich" khớp "Đặt lịch". */
function fold(s: string): string {
  return removeAccents(s).toLowerCase().replace(/\s+/g, " ").trim();
}

/**
 * Giữ mục có nhãn chứa chuỗi tìm; nhóm không còn mục nào thì bỏ hẳn. Chuỗi
 * rỗng trả nguyên danh sách. Cờ `folded` được gỡ để kết quả nằm trong ô
 * "Khác" cũng hiện ra ngay, không bắt bấm mở.
 */
export function filterNavGroups(groups: NavGroup[], query: string): NavGroup[] {
  const q = fold(query);
  if (!q) return groups;
  return groups
    .map((g) => ({ id: g.id, label: g.label, items: g.items.filter((n) => fold(n.label).includes(q)) }))
    .filter((g) => g.items.length > 0);
}

export function firstNavItem(groups: NavGroup[]): NavItem | undefined {
  return groups.find((g) => g.items.length > 0)?.items[0];
}
